module.exports = __webpack_public_path__ + "static/media/case-iphone-12-pro-max-min.356c2c15.png";